import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import browse from "./modules/browse"
import authentication from './modules/authentication'
import ui from './modules/ui'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth:authentication,
    uicomponents:ui,
    browse:browse,
  },
  state: {
    layout: '',
    dashboardTitle: 'Dash Board',
    menuData:null
  },
  actions,
  mutations,
  getters
})
export function createStore() {
  return store
}
//  For inheriting in other modules
export default store


// WEBPACK FOOTER //
// ./src/store/index.js